import { defineStore } from 'pinia'

export const useStockStore = defineStore('stock', {
    state: () => ({
        edit_stock_data:[],
        edit_sell_data:[],
        edit_delete_data:[],
    }),
    actions: {
        get_editing_ids() {
            let result = [];
            for (let i=0;i<this.edit_stock_data.length;i++) {
                result.push(this.edit_stock_data[i].medicine_id);
            }
            for (let i=0;i<this.edit_sell_data.length;i++) {
                if (result.indexOf(this.edit_sell_data[i].medicine_id) == -1) {
                    result.push(this.edit_sell_data[i].medicine_id);
                }
            }
            for (let i=0;i<this.edit_delete_data.length;i++) {
                if (result.indexOf(this.edit_delete_data[i].medicine_id) == -1) {
                    result.push(this.edit_delete_data[i].medicine_id);
                }
            }
            return result;
        },
        reset_data() {
            this.edit_stock_data.splice(0);
            this.edit_sell_data.splice(0);
            this.edit_delete_data.splice(0);
        },
    },
    persist: true,
})
